import React from 'react';
import {
  Box,
  Pagination,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Typography,
  useTheme,
  useMediaQuery
} from '@mui/material';

const SearchPagination = ({ count, page, rowsPerPage, onPageChange, onRowsPerPageChange }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  
  // Calculate total pages
  const totalPages = Math.ceil(count / rowsPerPage);
  
  // Calculate displayed range
  const startIndex = (page - 1) * rowsPerPage + 1;
  const endIndex = Math.min(startIndex + rowsPerPage - 1, count);
  
  return (
    <Box 
      sx={{ 
        display: 'flex', 
        justifyContent: 'space-between', 
        alignItems: 'center',
        flexDirection: { xs: 'column', sm: 'row' },
        mt: 3,
        mb: 2,
        py: 2,
        borderTop: `1px solid ${theme.palette.divider}`
      }}
    >
      <Box sx={{ mb: { xs: 2, sm: 0 } }}>
        <Typography variant="body2" color="text.secondary">
          Showing {startIndex}-{endIndex} of {count} results
        </Typography>
      </Box>
      
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <FormControl size="small" sx={{ minWidth: 80, mr: 2 }}>
          <InputLabel id="rows-per-page-label">Per Page</InputLabel>
          <Select
            labelId="rows-per-page-label"
            id="rows-per-page"
            value={rowsPerPage}
            label="Per Page"
            onChange={onRowsPerPageChange}
          >
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={20}>20</MenuItem>
            <MenuItem value={50}>50</MenuItem>
            <MenuItem value={100}>100</MenuItem>
          </Select>
        </FormControl>
        
        <Pagination 
          count={totalPages} 
          page={page} 
          onChange={onPageChange}
          color="primary"
          showFirstButton={!isMobile}
          showLastButton={!isMobile}
          size={isMobile ? "small" : "medium"}
        />
      </Box>
    </Box>
  );
};

export default SearchPagination;
